import { StyledEngineProvider } from '@mui/material/styles'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'hooks/user'
import { RootContainerProvider } from 'hooks/useRootContainer'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { queryClient } from 'queryClient'
import { lazy, StrictMode, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { router } from 'router'
import { RouterWithContext } from 'RouterWithContext'

import { GIT_REF, IS_ON_VERCEL, LD_CLIENT_ID } from './const'
import { getInitialLDContext } from './helpers/launchDarkly'

// @ts-ignore
window.CODE_VERSION = GIT_REF

// Render the app

const showDevtools = localStorage.getItem('showDevtools') === 'true'
const DevtoolsPanel = lazy(() => import('./DevtoolsPanel'))

;(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LD_CLIENT_ID,
    context: getInitialLDContext(),
    options: {
      sendEvents: false,
      ...(IS_ON_VERCEL
        ? {
            streamUrl: '/ld',
            baseUrl: '/ld',
            eventsUrl: '/ld',
            streaming: false,
          }
        : {}),
    },
  })

  const rootElement = document.getElementById('root')!
  if (rootElement?.innerHTML.trim() === '<title>Fingerprint Pro Dashboard</title>') {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
      <StrictMode>
        <StyledEngineProvider injectFirst>
          <LDProvider>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <RootContainerProvider value={rootElement}>
                  <RouterWithContext router={router} queryClient={queryClient} />
                  {showDevtools || process.env.NODE_ENV !== 'production' ? (
                    <Suspense fallback={null}>
                      <DevtoolsPanel router={router} queryClient={queryClient} />
                    </Suspense>
                  ) : null}
                </RootContainerProvider>
              </AuthProvider>
            </QueryClientProvider>
          </LDProvider>
        </StyledEngineProvider>
      </StrictMode>
    )
  }
})()
